import type { GetUsers200DataItem } from './getUsers200DataItem';

export type GetUsers200 = {
  data?: GetUsers200DataItem[];
};
